import { ComponentProps, useMemo } from 'react';
import { getCountriesList } from '@common';
import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type CountryProps = {
  span?: number;
} & Omit<ComponentProps<typeof SelectField>, 'fieldName' | 'data'>;

export const Country: React.FC<CountryProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();
  const countries = useMemo(() => getCountriesList(), []);

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <SelectField
        fieldName={`${prefix}.country`}
        label={t(`${TRANS_KEY}.COUNTRY_LABEL`)}
        data={countries}
        required
        searchable
        {...props}
      />
    </Grid.Col>
  );
};
